import type { CompRef } from '@wix/document-services-types';
import { AbstractComponentsPlatformService } from './AbstractComponentsPlatformService';
import { OperationSource } from '../panorama';
import type { EditorPointer } from '@wix/editor-document-logic-api';

export class PresetsPlatformService extends AbstractComponentsPlatformService {
  applyPreset(
    editorPointers: EditorPointer<CompRef>[] | EditorPointer<CompRef>,
    presetName: string,
  ) {
    this.dm.transactions.run(async () => {
      this.virtualElementProvider
        .buildVirtualElement(
          {
            editorPointers,
          },
          OperationSource.EDITOR,
        )
        .getAPI()
        .query.applyPreset({ key: presetName });
    });
  }
}
